var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from '../../atoms/Icon';
import { linkStyle } from '../../links/Link/link.linaria';
import classNames from 'classnames';
import BaseButton from '../BaseButton';
import { linkButtonStyle } from './linkButton.linaria';
function LinkButton(_a) {
    var { icon, iconSize, children, type, className, variant, size } = _a, rest = __rest(_a, ["icon", "iconSize", "children", "type", "className", "variant", "size"]);
    return (<BaseButton className={classNames(linkButtonStyle, className, variant && `variant-${variant}`, size && `size-${size}`, linkStyle)} {...rest}>
      <span className="link-text">{children}</span>
      {!!icon && <Icon size={iconSize} icon={icon}/>}
    </BaseButton>);
}
LinkButton.defaultProps = {
    icon: undefined,
    iconSize: 'small',
    variant: undefined,
    size: undefined,
};
export default LinkButton;
